import {TranslatedModel, TranslationModel} from "../../api/Translation";

export type Translations = TranslatedModel<TranslatedModel<typeof translationModel>>;

export const translationModel = {
    applicantStepHeader: ["request", "applicantStepHeader"],
    serviceStepHeader: ["request", "serviceStepHeader"],
    consultationServiceStepHeader: ["request", "consultationServiceStepHeader"],
    admissionStepHeader: ["request", "admissionStepHeader"],
    budgetStepHeader: ["request", "budgetStepHeader"],
    visaStepHeader: ["request", "visaStepHeader"],
    languageCourseStepHeader: ["request", "languageCourseStepHeader"],
    documentStepHeader: ["request", "documentStepHeader"],
    otherStepHeader: ["request", "otherStepHeader"],
    examStepHeader: ["request", "examStepHeader"],
    finishStepHeader: ["request", "finishStepHeader"],
    confirmationStepHeader: ["request", "confirmationStepHeader"],
    confirmationStepText: ["request", "confirmationStepText"],
    formProgressThreeStepsLeft: ["request", "formProgressThreeStepsLeft"],
    formProgressTwoStepsLeft: ["request", "formProgressTwoStepsLeft"],
    formProgressOneStepLeft: ["request", "formProgressOneStepLeft"],
    formProgressZeroStepsLeft: ["request", "formProgressZeroStepsLeft"],
    budgetStepText: ["request", "budgetStepText"],
    otherStepText: ["request", "otherStepText"],
    finishStepText: ["request", "finishStepText"],
    nextButton: ["request", "Proceed"],
    learnMoreButton: ["request", "Learn more"],
    subscribeButton: ["main", "Subscribe"],
    speciality: ["main", "Speciality"],
    enterSpeciality: ["main", "Enter your specialty"],
    comment: ["main", "Comment"],
    whatToKnow: ["main", "What do you want to know"],

    applicantStepApplicantTypeLabel: ["input-label", "Applicant type"],
    applicantStepApplicantStageLabel: ["input-label", "Applicant stage"],

    admissionStepCountryInputLabel: ["request", "admissionStepCountryInputLabel"],
    admissionStepCountryInputPlaceholder: ["request", "admissionStepCountryInputPlaceholder"],
    admissionStepLanguageInputLabel: ["request", "admissionStepLanguageInputLabel"],
    admissionStepLanguageInputPlaceholder: ["request", "admissionStepLanguageInputPlaceholder"],
    admissionStepLanguageLevelInputLabel: ["request", "admissionStepLanguageLevelInputLabel"],

    degreeInputLabel: ["request", "degreeInputLabel"],
    degreeInputPlaceholder: ["request", "degreeInputPlaceholder"],

    documentTypeInputLabel: ["request", "documentTypeInputLabel"],
    documentTypeInputPlaceholder: ["request", "documentTypeInputPlaceholder"],
    documentScopeInputLabel: ["request", "documentScopeInputLabel"],
    documentDeadlineInputLabel: ["request", "documentDeadlineInputLabel"],
    documentLanguageInputLabel: ["request", "documentLanguageInputLabel"],
    documentLanguageInputPlaceholder: ["request", "documentLanguageInputPlaceholder"],

    languageCourseLanguageInputLabel: ["request", "languageCourseLanguageInputLabel"],
    languageCourseLanguageInputPlaceholder: ["request", "languageCourseLanguageInputPlaceholder"],
    languageCourseLanguageLevelInputLabel: ["request", "languageCourseLanguageLevelInputLabel"],
    languageCourseCountryInputLabel: ["request", "languageCourseCountryInputLabel"],
    languageCourseCountryInputPlaceholder: ["request", "languageCourseCountryInputPlaceholder"],
    languageCourseCountryInputHint: ["request", "languageCourseCountryInputHint"],
    languageCourseTimeToStartInputLabel: ["request", "languageCourseTimeToStartInputLabel"],
    languageCourseDurationInputLabel: ["request", "languageCourseDurationInputLabel"],

    visaStepCountryInputLabel: ["request", "visaStepCountryInputLabel"],
    visaStepCountryInputHint: ["request", "visaStepCountryInputHint"],
    visaStepCountryInputPlaceholder: ["request", "visaStepCountryInputPlaceholder"],
    visaStepDegreeInputLabel: ["request", "visaStepDegreeInputLabel"],
    visaStepDegreeInputPlaceholder: ["request", "visaStepDegreeInputPlaceholder"],
    visaStepStartMonthInputLabel: ["request", "visaStepStartMonthInputLabel"],
    visaStepStartMonthInputPlaceholder: ["request", "visaStepStartMonthInputPlaceholder"],
    visaStepStartYearInputLabel: ["request", "visaStepStartYearInputLabel"],
    visaStepStartYearInputPlaceholder: ["request", "visaStepStartYearInputPlaceholder"],

    webinarDetailsStepHeader: ["request", "webinarDetailsStepHeader"],
    webinarDetailsCustomerTypeInputLabel: ["input-label", "Customer type"],
    webinarDetailsCustomerTypeInputPlaceholder: ["input-placeholder", "customer type"],
    webinarDetailsStepStudentAgeInputLabel: ["input-label", "Student age"],
    webinarDetailsStepStudentAgeInputPlaceholder: ["input-placeholder", "student age"],
    webinarDetailsStepCommentInputLabel: ["input-label", "Comment"],
    webinarDetailsStepCommentInputPlaceholder: ["input-placeholder", "comment"],
    webinarSuccessStepHeader: ["request", "webinarSuccessStepHeader"],
    webinarSuccessStepText: ["request", "webinarSuccessStepText"],
    webinarSuccessStepButton: ["request", "webinarSuccessStepButton"],

    careerCounsellingStepHeader: ["request", "careerCounsellingStepHeader"],
    careerCounsellingStepCareerCounsellingTypeInputLabel: ["input-label", "Career counselling type"],
    careerCounsellingStepCareerCounsellingTypeInputPlaceholder: ["input-placeholder", "career counselling type"],
    careerCounsellingStepStudentAgeInputLabel: ["input-label", "Student age"],
    careerCounsellingStepStudentAgeInputPlaceholder: ["input-placeholder", "student age"],
    careerCounsellingStepCommentInputLabel: ["input-label", "Comment"],
    careerCounsellingStepCommentInputPlaceholder: ["input-placeholder", "comment"],

    admissionPreparationStepHeader: ["request", "admissionPreparationStepHeader"],
    admissionPreparationStepAdmissionPreparationTypeInputLabel: ["input-label", "Admission preparation type"],
    admissionPreparationStepAdmissionPreparationTypeInputPlaceholder: ["input-placeholder", "admission preparation type"],
    admissionPreparationStepStartMonthInputLabel: ["request", "admissionPreparationStepStartMonthInputLabel"],
    admissionPreparationStepStartMonthInputPlaceholder: ["request", "admissionPreparationStepStartMonthInputPlaceholder"],
    admissionPreparationStepStartYearInputLabel: ["request", "admissionPreparationStepStartYearInputLabel"],
    admissionPreparationStepStartYearInputPlaceholder: ["request", "admissionPreparationStepStartYearInputPlaceholder"],
} satisfies TranslationModel;